import { axiosInstance } from '@configs/axios/axiosInstance';

import type { User } from '../types/user.types';
import type { GetUserRequest } from './getUser.types';

/**
 * Fetch a single B2C user by ID for a given organization.
 * Endpoint: GET /users/:userId
 *
 * `organizationId` is sent as the X-Organization-ID request header.
 */
export async function getUser(params: GetUserRequest): Promise<User> {
  const { userId, organizationId } = params;

  const response = await axiosInstance.get<User>(`/users/${userId}`, {
    headers: { 'X-Organization-ID': organizationId },
  });

  return response.data;
}
